<script lang="ts" setup>
/*
 * This is a combined layout from nuxt-magento and nuxt-strapi.
 */

provideHeadingContext()

const template = ''
</script>

<template>
  <div
    class="layout layout--default"
    :class="template"
  >
    <HeaderTop class="layout__header-top" />

    <HeaderComponent class="layout__header" />

    <AppPromoBanner class="layout__promo-banner" />

    <main
      id="main"
      class="layout__main"
    >
      <slot />
    </main>

    <FooterComponent class="layout__footer" />

    <CartAdded />
    <CartRestore />
    <ProductOfferFormDialog />
    <ProductReservationFormDialog />
    <StorePickerDialog name="store-picker-dialog" />
  </div>
</template>

<style>
@import url("~layers/layouts/default.css");
</style>
